import { z } from 'zod';

import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const ZodSuccessResponse = z.object({
  success: z.boolean(),
});

export const ZodErrorResponse = z.object({
  error: ZodTrimmedString,
});

export const ZodMessageResponse = z.object({
  message: ZodTrimmedString,
});

export const ZodEndpointResponse = z.union([
  ZodSuccessResponse,
  ZodErrorResponse,
  ZodMessageResponse,
]);

export type SuccessResponse = z.infer<typeof ZodSuccessResponse>;
export type ErrorResponse = z.infer<typeof ZodErrorResponse>;
export type MessageResponse = z.infer<typeof ZodMessageResponse>;
export type EndpointResponse = z.infer<typeof ZodEndpointResponse>;

export const ZodCursorData = z.object({
  next: ZodTrimmedString.nullable(),
});
export type CursorData = z.infer<typeof ZodCursorData>;
